import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { gql } from '@apollo/client'
import { CALENDAR_REPORT_QUERY } from '../../../graphql.js'
import { Table, Alert } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import '../Custom.css'
import './CalendarReport.css'
import { getData } from '../CustomUtils.js'
import ColumnHeadings from '../ColumnHeadings.js'
// import LargeRowHandler from '../LargeRowHandler.js'
// import { getTenant } from '../../../utils.js'

const CALENDAR_REPORT = gql(CALENDAR_REPORT_QUERY)

export default function CalendarReport({ reportGroup }) {
  console.log('CalendarReport rendered: ', reportGroup)

  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    getData(null, CALENDAR_REPORT, 'calendarReport', setResults, setGraphQLErrors, 'reportGroup', reportGroup)
  }, [reportGroup])

  let resultRows = []
  let lastDate
  let color = 'lightyellow'

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else if (reportGroup === 'NJ') {
    // nj
    for (let i = 0; i < results.reportData.length; i++) {
      if (lastDate !== results.reportData[i][4]) {
        if (color === 'lightyellow') {
          color = 'lightblue'
        } else {
          color = 'lightyellow'
        }
      }
      const row =
        <tr style={{ backgroundColor: color }}>
          <td>{results.reportData[i][0]}</td>
          <td>{results.reportData[i][1]}</td>
          <td>{results.reportData[i][2]}</td>
          <td>{results.reportData[i][3]}</td>
          <td>{results.reportData[i][4]}</td>
          <td>{results.reportData[i][5]}</td>
          <td>{results.reportData[i][6]}</td>
          <td>{results.reportData[i][7]}</td>
          <td>{results.reportData[i][8]}</td>
          <td><Link to={`/object/${results.reportData[i][10]}`}>{results.reportData[i][9]}</Link></td>
        </tr>
      resultRows.push(row)
      lastDate = results.reportData[i][4]
    }
  } else if (reportGroup === 'NY') {
    //ny
    for (let i = 0; i < results.reportData.length; i++) {
      if (lastDate !== results.reportData[i][3]) {
        if (color === 'lightyellow') {
          color = 'lightblue'
        } else {
          color = 'lightyellow'
        }
      }
      const row =
        <tr style={{ backgroundColor: color }}>
          <td>{results.reportData[i][0]}</td>
          <td>{results.reportData[i][1]}</td>
          <td>{results.reportData[i][2]}</td>
          <td>{results.reportData[i][3]}</td>
          <td>{results.reportData[i][4]}</td>
          <td>{results.reportData[i][5]}</td>
          <td>{results.reportData[i][6]}</td>
          <td>{results.reportData[i][7]}</td>
          <td>{results.reportData[i][8]}</td>
          <td>{results.reportData[i][9]}</td>
          <td>{results.reportData[i][10]}</td>
          <td>{results.reportData[i][11]}</td>
          <td><Link to={`/object/${results.reportData[i][13]}`}>{results.reportData[i][12]}</Link></td>
        </tr>
      resultRows.push(row)
      lastDate = results.reportData[i][3]
    }
  }
  //const csvUrl = `${process.env.REACT_APP_SERVER}/csv/${getTenant()}/custom/TKCal/calendarReport/calendarReport.csv?inputs=${reportGroup}`
  return (
    <div className="custom-scroll">
      {/* <div style={{ textAlign: 'center', margin: '10px 0px' }}>
        <LargeRowHandler csvUrl={csvUrl} resultsLength={results.reportData.length} />
      </div> */}
      <Table bordered className="custom-table">
        <thead>
          <ColumnHeadings results={results} noNumberRow={true} />
        </thead>
        <tbody>
          {resultRows}
        </tbody>
      </Table>
    </div>
  )
}

